/**
 * @generated SignedSource<<9abd44cc48882f651cc012b385399d8d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateCountryInput = {
  name: string;
};
export type CountriesListAddMutation$variables = {
  input: CreateCountryInput;
};
export type CountriesListAddMutation$data = {
  readonly createCountry: {
    readonly id: string;
  };
};
export type CountriesListAddMutation = {
  response: CountriesListAddMutation$data;
  variables: CountriesListAddMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Country",
    "kind": "LinkedField",
    "name": "createCountry",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CountriesListAddMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CountriesListAddMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "fe39a2138e44990f2e6e6b4d597e5c4d",
    "id": null,
    "metadata": {},
    "name": "CountriesListAddMutation",
    "operationKind": "mutation",
    "text": "mutation CountriesListAddMutation(\n  $input: CreateCountryInput!\n) {\n  createCountry(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "9b7fc53a07ee59e30551b2e69a2f3033";

export default node;
